export default __webpack_public_path__ + "static/media/parmentier.62112315.jpg";